<template>
    <div class="add-new-wrapper">
        <span class="transition cursor-pointer duration-200 rounded button icon-plus icon-plus-right bg-white/25 flex-1" :class="[disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : '']" @click="click">
            {{ label }}
        </span>
    </div>
</template>

<script>
export default {
    name: "AddNewButtonComponent",
    props: {
        id: { type: String, default: "" }, // "id" prop for naming the input
        label: { type: String, default: "" }, // Label used for the input
        disabled: { type: Boolean, default: false } // Prop to set if the component is disabled or not
    },
    components: {
    },
    computed: {},
    data: function () {
        return {
        };
    },
    methods:{
        click(event){
            if(!this.disabled) this.$emit('click', event)
        }
    }
};
</script>
